// extracted by mini-css-extract-plugin
module.exports = {"footer":"Aboutfooter_footer__RO_Yr","one":"Aboutfooter_one__1qIsg","lastcontent":"Aboutfooter_lastcontent__ynegQ"};